module.exports = __webpack_public_path__ + "static/img/detect11.10d3836.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/detect11.png
// module id = 585
// module chunks = 4